export enum EntranceLock {
  None,
  Unknown,
  Bombos,
  Ether,
  Quake
}
